import {Typography, Grid} from '@mui/material';
import {useContext} from 'react';
import {CartContext} from '../../../../api/context';
import {useNavigate} from 'react-router-dom';

export const CartTotalView = () => {
    const cartItems = Array.from(useContext(CartContext)?.getCart()?.cartItems.values() ?? []);
    const isCartEmpty = cartItems.length === 0;
    const navigateTo = useNavigate();

    return (
        <>
            <br />
            <Grid container>
                <Grid item md={3} xs={12} sm={12} lg={3} xl={3}>
                    <div
                        onClick={() => {
                            if (!isCartEmpty) {
                                // navigate to fetch cart page
                                navigateTo('/cart/review');
                            } else {
                                alert('Cart is empty, please create cart first');
                            }
                        }}
                        style={{
                            paddingTop: 12,
                            paddingBottom: 12,
                            paddingLeft: 32,
                            borderRadius: 8,
                            paddingRight: 32,
                            cursor: isCartEmpty ? 'default' : 'pointer',
                            backgroundColor: isCartEmpty ? 'gray' : '#15171c',
                        }}>
                        <center>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    color: 'white',
                                    fontFamily: 'Poppins',
                                }}
                                variant='body1'>
                                Confirm order
                            </Typography>
                        </center>
                    </div>
                </Grid>
            </Grid>
        </>
    );
};
